import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: -0.5em;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-left: ", "em solid ", ";\n  display: flex;\n  overflow: visible;\n  padding-bottom: 1.357em;\n  padding-left: 1em;\n  position: relative;\n\n  &::before {\n    background-color: ", ";\n    border-radius: 50%;\n    content: '';\n    height: ", "em;\n    left: -", "em;\n    position: absolute;\n    top: 0;\n    width: ", "em;\n  }\n\n  &:last-child {\n    border-left-color: transparent;\n    padding-bottom: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { color, typography } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var BULLET_SIZE = 5;
var BORDER_WIDTH = 1;
var StyledTimelineItem = styled.li(_templateObject(), BORDER_WIDTH / typography.defaultFontSize, color.border, color.palette.grey200, BULLET_SIZE / typography.defaultFontSize, Math.ceil((BULLET_SIZE + BORDER_WIDTH) / 2) / typography.defaultFontSize, BULLET_SIZE / typography.defaultFontSize);
var TimelineItemContent = styled.div(_templateObject2());
export function TimelineItem(_ref) {
  var children = _ref.children;
  return React.createElement(StyledTimelineItem, {
    "data-e2e": getE2eLabel('timeline-item')
  }, React.createElement(TimelineItemContent, null, children));
}